import TYPES from './types';

import { messageType, subType, messageTypeValues} from '../uilts'

const typeReduce = messageTypeValues.reduce((ac,cr)=> {
  ac[cr] = {
    afterLastSize: 0,
    beforeFromSize: 0,
    data: [],
    dataSize: 0,
    from: null,
    fromId: null,
    isMore: true,
    last: null,
    lastId: null,
    pageSize: 20,
    total: 0,
  };
  return ac;
},{})

const init = () => {
  return {
    token: '',
    catalogsLoading: false,
    messageLoading: false,
    catalogs: [],
    activeCatalog: '',
    ...typeReduce
  };
};



const reducer = (state, action) => {
  switch (action.type) {
    case TYPES.MESSAGEPUSH_CATALOGS_SELECT: {
      return {
        ...state,
        activeCatalog: action.payload,
      }
    }
    case TYPES.MESSAGEPUSH_CATALOGS_GET: {
      if(action.pending) {
        return {
          ...state,
          catalogsLoading: true,
        }
      }
      if(action.error) {
        return {
          ...state,
          catalogsLoading: false,
        }
      }
      return {
        ...state,
        catalogsLoading: false,
        catalogs: action.payload.data.filter(catalog=> messageTypeValues.includes(catalog.mainType)),
      }
    }
    case TYPES.MESSAGEPUSH_CATALOGS_GET_BYPUSH: {
      if(action.pending) {
        return {
          ...state,
          catalogsLoading: true,
        }
      }
      if(action.error) {
        return {
          ...state,
          catalogsLoading: false,
        }
      }
      return {
        ...state,
        catalogsLoading: false,
        catalogs: action.payload.data.filter(catalog=> messageTypeValues.includes(catalog.mainType)).map(catalog=> {
          if(catalog.mainType === action.meta) {
            return {
              ...catalog,
              isRead: true,
            }
          }
          return catalog;
        })
        
      }
    }
    case TYPES.MESSAGEPUSH_CATALOGS_DELETE: {
      if(action.pending || action.error) {
        return {
          ...state,
        }
      }
      const deleledType = action.meta
      return {
        ...state,
        catalogs: state.catalogs.filter(catalog=> catalog.mainType !== deleledType),
        activeCatalog: state.activeCatalog === deleledType ? '' : state.activeCatalog
      }
    }
    case TYPES.MESSAGEPUSH_CATALOGS_DELETEALL: {
      if(action.pending || action.error) {
        return {
          ...state,
        }
      }
      return {
        ...state,
        catalogs: [],
        activeCatalog: ''
      }
    }
    case TYPES.MESSAGEPUSH_CATALOGS_READ_PREV: {
      const readedType = action.payload
      return {
        ...state,
        catalogs: state.catalogs.map(catalog=> {
          if(catalog.mainType === readedType) {
            return {
              ...catalog,
              isRead: true,
            }
          }
          return catalog;
        })
      }
    }

    case TYPES.MESSAGEPUSH_CATALOGS_READ: {
      if(action.pending || action.error) {
        return {
          ...state,
        }
      }
      const readedType = action.meta
      return {
        ...state,
        catalogs: state.catalogs.map(catalog=> {
          if(catalog.mainType === readedType) {
            return {
              ...catalog,
              isRead: true,
            }
          }
          return catalog;
        })
      }
    }
    
    case TYPES.MESSAGEPUSH_MESSAGE_GET: {
      if(action.pending) {
        return {
          ...state,
          messageLoading: true,
        }
      }
      if(action.error) {
        return {
          ...state,
          messageLoading: false,
        }
      }
      return {
        ...state,
        messageLoading: false,
        [action.meta]: action.payload.data,
      }
    } 
    case TYPES.MESSAGEPUSH_TOKEN_GET: {
      if(action.pending || action.error) {
        return {
          ...state,
        }
      }
      return {
        token: action.payload.data,
      }
    }
    case TYPES.MESSAGEPUSH_MESSAGE_DELETE: {
      if(action.pending || action.error) {
        return {
          ...state,
        }
      }
      const {msgId, type} = action.meta;
      return {
        ...state,
        [type]:{
          ...state[type],
          data: state[type].data.filter(msg=>msg.id !== msgId)
        } 
      }
    }
    case TYPES.MESSAGEPUSH_RESET: {
      return init()
    }
    default: {
      return {
        ...state
      }
    }
  };
}

export default {reducer, init};


// WEBPACK FOOTER //
// ./src/pages/MessagePush/state/reducer.js